export class ValidationPurchaseRequestService {
  isNotEqual({ data, projectNumber, excludeItemId }) {
    
    var isAlreadyEqual = false;
    if (excludeItemId === null) {
      console.log("add kısmı");

      isAlreadyEqual = data.some((t) => t.projectNumber === projectNumber);
    } else {
      console.log("edit kısmı");
      isAlreadyEqual = data.some(
        (t) => t.projectNumber === projectNumber && t.id !== excludeItemId
      );
    }    

    // alert(isAlreadyEqual)
    return !isAlreadyEqual;
  }
}
